// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

export default function CutoffOverwriteModal({ vm }: { vm: any }) {
  if (!vm.overwriteOpen) return null;
  return (
    <div
      onClick={vm.cancelOverwrite}
      style={sx(
        `position:fixed;inset:0;z-index:70;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`
      )}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={sx(
          `width:100%;max-width:520px;max-height:calc(100vh - 48px);overflow:auto;background:#fff;border-radius:24px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5);padding:24px`
        )}
      >
        <div style={sx(`font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:var(--ink-4)`)}>
          Confirm cutoff move
        </div>
        <h4 style={sx(`margin:8px 0 6px`)}>{vm.overwriteTitle}</h4>
        <p style={sx(`font-size:12.5px;color:var(--ink-3);margin:0 0 16px;line-height:1.45`)}>
          Moving the cutoff forward re-binds {vm.overwriteCount} from database actuals. Typed forecast values in those months are replaced. Months with no bound actual stay blank.
        </p>
        <div style={sx(`border:1px solid #DCE4F2;border-radius:12px;overflow:hidden;margin-bottom:16px`)}>
          <div style={sx(`display:flex;padding:8px 12px;background:#F5F8FA;font-size:10.5px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4)`)}>
            <span style={sx(`flex:1`)}>Period</span>
            <span style={sx(`flex:none;width:90px;text-align:right`)}>Forecast</span>
            <span style={sx(`flex:none;width:90px;text-align:right`)}>Actual</span>
            <span style={sx(`flex:none;width:80px;text-align:right`)}>Delta</span>
          </div>
          {(vm.overwriteRows || []).map((row, idx) => (
            <div key={idx} style={sx(`display:flex;padding:8px 12px;border-top:1px solid #F0F4FA;font-size:12.5px;font-variant-numeric:tabular-nums`)}>
              <span style={sx(`flex:1;color:var(--ink)`)}>{row.period}</span>
              <span style={sx(`flex:none;width:90px;text-align:right;color:var(--ink-3)`)}>{row.forecast}</span>
              <span style={sx(`flex:none;width:90px;text-align:right;color:var(--ink-3)`)}>{row.actual}</span>
              <span style={sx(`flex:none;width:80px;text-align:right;color:${row.fg};font-weight:500`)}>{row.delta}</span>
            </div>
          ))}
        </div>
        <label style={sx(`display:block;margin-bottom:14px`)}>
          <span style={sx(`display:block;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4);margin-bottom:6px`)}>
            Type OVERWRITE to confirm
          </span>
          <input
            className="gmFocus"
            value={vm.overwriteText}
            onChange={vm.onOverwriteText}
            placeholder="OVERWRITE"
            style={sx(
              `width:100%;height:38px;padding:0 12px;border:1px solid #C8D4EA;border-radius:8px;font-family:inherit;font-size:13px;letter-spacing:0.06em;color:var(--ink);background:#fff;outline:none;box-sizing:border-box`
            )}
          />
        </label>
        <div style={sx(`display:flex;gap:8px;justify-content:flex-end`)}>
          <button
            onClick={vm.cancelOverwrite}
            style={sx(
              `flex:none;height:34px;padding:0 14px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`
            )}
          >
            Cancel
          </button>
          <button
            onClick={vm.confirmOverwrite}
            disabled={!vm.overwriteReady}
            style={sx(
              `flex:none;height:34px;padding:0 16px;border:none;border-radius:999px;background:${vm.overwriteBg};color:${vm.overwriteFg};font-family:inherit;font-size:12.5px;font-weight:500;cursor:${vm.overwriteReady ? 'pointer' : 'default'}`
            )}
          >
            Move cutoff
          </button>
        </div>
      </div>
    </div>
  );
}
